'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var t = require('react');

var DisableFeatureContext = /*#__PURE__*/t.createContext({
  subdomain: null,
  disableFeature: null,
  isReady: false
});
var DisableFeatureContextConsumer = DisableFeatureContext.Consumer;
var DisableFeatureContextProvider = DisableFeatureContext.Provider;

exports.DisableFeatureContext = DisableFeatureContext;
exports.DisableFeatureContextConsumer = DisableFeatureContextConsumer;
exports.DisableFeatureContextProvider = DisableFeatureContextProvider;
exports.default = DisableFeatureContext;
//# sourceMappingURL=DisableFeatureContext.js.map
